module.exports = __webpack_public_path__ + "img/tecnici_stats.eb516339.png";